import { z } from 'zod';

/** @see AppleRetail.StoreEvents.DataModels.StoreEventStatus */
export type StoreEventStatus = z.infer<typeof storeEventStatusSchema>;

/** @see AppleRetail.StoreEvents.DataModels.StoreEventType */
export type StoreEventType = z.infer<typeof storeEventTypeSchema>;

/** @see AppleRetail.StoreEvents.DataModels.StoreEventStatus */
export const storeEventStatusSchema = z.enum([
	'NewEvent',
	'Saved',
	'ReadyForSubmission',
	'SubmissionPending',
	'Submitted',
	'Open',
	'Canceled',
	'Complete',
	'EarlyManagementKitPicked',
	'EarlyManagementKitShipped',
	'EarlyManagementKitDelivered',
	'FullKitPicked',
	'FullKitShipped',
	'FullKitDelivered',
	'Archived',
]);

export const filterableStoreEventStatusSchema = storeEventStatusSchema.exclude([
	'ReadyForSubmission',
	'SubmissionPending',
]);

/** @see AppleRetail.StoreEvents.DataModels.StoreEventType */
export const storeEventTypeSchema = z.enum(['NewStore', 'Upgrade', 'Relocation', 'Eagle']);
